<template>
  <div @click="showFirmwareVersions = true" style="cursor: pointer; " >
    <v-dialog
      v-model="showFirmwareVersions"
      max-width="700px"
    >
      <videon-card :heading="device.deviceName() + ' Firmware Versions'" showClose="true" @close="showFirmwareVersions = false">
        <div v-if="!device.state" class="pa-5 pb-2">
          <v-alert outlined type="error">
            Device state is unknown
          </v-alert>
        </div>
        <v-card-text>
          <div v-if="device.state" class="ma-1 mb-5">
            <v-row>
              <videon-state-tile
                heading="Daemon"
                minWidth="140px"
              >
                {{ device.daemon_version.original }}
              </videon-state-tile>
              <videon-state-tile
                heading="System"
                minWidth="140px"
              >
                {{ device.system_version }}
              </videon-state-tile>
              <videon-state-tile
                heading="Cloud Agent"
                minWidth="140px"
              >
                {{ device.cloud_version.original }}
              </videon-state-tile>
            </v-row>
          </div>
          
          <device-firmware-updater :device="device" @close='showFirmwareVersions = false'/>
          
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-tooltip 
      open-on-hover
      open-delay="500"
      right
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" v-if="device.firmwareApplyActive" class="d-inline-flex align-center info--text"><v-icon color="info" class="mr-1">update</v-icon> Updating...</div>
        
        <div v-bind="attrs" v-on="on" v-else-if="downloadLabel" class="d-inline-flex align-center info--text"><v-icon color="info" class="mr-1">file_download</v-icon> {{ downloadLabel }}</div>
        
        <div v-bind="attrs" v-on="on" v-else-if="isUpdating" class="d-inline-flex align-center" :class="labelColor"><v-icon :color="iconColor" class="mr-1">update</v-icon> Updating...</div>
        
        <div v-bind="attrs" v-on="on" v-else-if="awaitingReboot" class="d-inline-flex align-center red--text"><v-icon color="red" class="mr-1">refresh</v-icon> Reboot to update</div>
        
        <div v-bind="attrs" v-on="on" v-else-if="hasUpdates" class="d-inline-flex align-center" :class="labelColor"><v-icon :color="iconColor" class="mr-1">system_update_alt</v-icon> {{ device.firmware_version }}</div>
        
        <div v-bind="attrs" v-on="on" class="d-inline-flex align-center" v-else>{{ device.firmware_version }}</div>
      </template>
      <span>
        Firmware: {{ device.firmware_version }}<br/>
        Cloud Agent: {{ device.state.cloud_version }}
      </span>
    </v-tooltip>
    
  </div>
</template>

<script>
  import DeviceFirmwareUpdater from '../../device/components/DeviceFirmwareUpdater.vue'
  
  export default {
    name: 'FirmwareVersionLabel',
    props: ['device'],
    components: {
      DeviceFirmwareUpdater
    },
    computed: {
      labelColor() {
        if (this.device.isOnline() && this.hasUpdates) {
          return 'info--text'
        }
        return 'disabled--text'
      },
      iconColor() {
        if (this.device.isOnline() && this.hasUpdates) {
          return 'info'
        }
        return 'disabled'
      },
      // Label reflects device firmware (daemon/system) only; cloud agent updates are separate in the dialog.
      hasUpdates() {
        if (this.device.device_type === 'encoder' && this.device.updatesAvailable) {
          var u = this.device.updatesAvailable
          return !!(u.daemon || u.system || u.firmware)
        }
        return this.device.hasUpdates()
      },
      awaitingReboot() {
        if (!this.device.isOnline() || !this.device.state || !this.device.state.update_state) {
          return false
        }
        var h = this.$helpers
        var us = this.device.state.update_state
        if (this.device.product_name === 'edgecaster_max') {
          var daemonMax = h.findUpdateStateEntry(us, 'daemon')
          if (daemonMax && h.updateStateStatusNeedsRebootPrompt(daemonMax.status)) {
            return true
          }
          var sysMax = h.findUpdateStateEntry(us, 'system')
          return !!(sysMax && h.updateStateStatusNeedsRebootPrompt(sysMax.status))
        }
        if (this.device.product_name === 'edgecaster') {
          var names = ['daemon', 'system', 'firmware']
          for (var i = 0; i < names.length; i++) {
            var entry = h.findUpdateStateEntry(us, names[i])
            if (entry && h.updateStateStatusNeedsRebootPrompt(entry.status)) {
              return true
            }
          }
          return false
        }
        return false
      },
      isUpdating() {
        return this.device.isUpdating()
      },
      downloadLabel() {
        var rows = this.device.state && this.device.state.update_state
        var percent = ''
        var downloading = false
        if (Array.isArray(rows)) {
          for (var i = 0; i < rows.length; i++) {
            var row = rows[i]
            var status = this.$helpers.normalizeUpdateStateStatus(row && row.status)
            if (status.indexOf('downloading') === -1) {
              continue
            }
            downloading = true
            if (row.progress_percent != null && row.progress_percent !== '') {
              percent = row.progress_percent
            }
          }
        }
        if (!downloading && !(this.device.firmwareDownloadActive)) {
          return ''
        }
        if (percent !== '') {
          return 'Downloading (' + percent + '%)'
        }
        return 'Downloading...'
      }
    },
    data() {
      return {
        showFirmwareVersions: false,
      }
    },
    watch: {
      showFirmwareVersions(open) {
        if (!open && this.device && typeof this.device.clearFirmwareUpdateDialogFeedback === 'function') {
          this.device.clearFirmwareUpdateDialogFeedback()
        }
      },
    },
  }
</script>